export function availableSellingUnits(packingMode: { quantity: number, unit1: string, unit2: string }[]): string[] {
  let sellingUnits: string[] = [];
  packingMode.forEach((packingStage: { quantity: number, unit1: string, unit2: string }) => {
    const { unit1, unit2 } = packingStage;
    if(!sellingUnits.includes(unit1)) {
      sellingUnits.push(unit1);
    }
    if(!sellingUnits.includes(unit2)) {
      sellingUnits.push(unit2);
    }
  });
  sellingUnits = sellingUnits.filter(unit => unit != 'pallet');
  return sellingUnits;
}